module.exports = __webpack_public_path__ + "img/ar_small_pri.8a447a18.svg";